{
    "raporsatis": {
        "Baslik": "Satış Raporu",
        "Tarih": "Tarih",
        "Musteri": "Sigortalı",
        "Urun": "Ürün",
        "Tutar": "Tutar",
        "Kullanici": "Kullanıcı",
        "Durum": "Durum",
        "PoliceNo": "Poliçe No",
        "Aciklama": "Not",
        "IptalTarihi": "İptal",
        "Kur": "Kur",
        "Onayli": "Onaylı",
        "Onaysiz": "Onaysız",
        "Iptal": "İptal",
        "Cayma": "Cayma",
        "Toplam": "Toplam",
        "Adet": "Adet",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "BaslangicTarihi": "Başlangıç Tarihi",
        "BitisTarihi": "Bitiş Tarihi",
        "SatisTipi": "Satış Tipi",
        "OdemeSekli": "Ödeme Şekli",
        "Kapsam": "Kapsam",
        "Takim": "Takım",
        "Sube": "Şube",
        "Istatistikler": "İstatistikler",
        "OzetGosterge": "Özet Gösterge",
        "ToplamSatisAdedi": "Toplam Satış Adedi",
        "ToplamLira": "TL Tutar",
        "ToplamDolar": "Dolar Tutar",
        "ToplamAPE": "APE Tutar",
        "OnayOrani": "Onay Oranı",
        "Bekliyor": "Bekliyor",
        "Basari": "Başarı",
        "Duzenle": "Düzenle",
        "SigortaEttiren": "Sigorta Ettiren",
        "Kaydet": "Kaydet",
        "Sil": "Sil",
        "SilmeOnayi": "Silme Onayı",
        "SilmeMesaji": "Bu kaydı silmek istediğinize emin misiniz?",
        "GeriAlOnayi": "Geri Al Onayı",
        "GeriAlMesaji": "İptal bilgisini geri almak istediğinize emin misiniz?",
        "DurumOnayi": "Durum Değişiklik Onayı",
        "DurumMesaji": "Satış durumunu değiştirmek istediğinize emin misiniz?",
        "Evet": "Evet",
        "Kendi": "Kendi",
        "Tam": "Tam",
        "Hepsi": "Hepsi",
        "Yeni": "Yeni",
        "Yenileme": "Yenileme",
        "EkBelge": "Ek Belge",
        "Pesin": "Peşin",
        "Taksitli": "Taksitli",
        "KrediKarti": "Kredi Kartı",
        "PoliceNoPlaceholder": "Poliçe no giriniz",
        "AciklamaPlaceholder": "Not ekleyin...",
        "Network": "Network",
        "Sağlık": "Sağlık",
        "Doğum": "Doğum",
        "AktarimTutar": "Transfer Bedeli (₺)",
        "KalanGunRaporu": "Kalan Gün Raporu",
        "KullaniciListesi": "Kullanıcı Listesi",
        "IptalTarihiSecin": "İptal Tarihi Seçin",
        "TarihSecin": "Tarih seçin",
        "Tamam": "Tamam",
        "IptalGir": "İptal Gir",
        "IptalSil": "İptal Sil"
    }
}
